import {
  ColumnChooser,
  ColumnDirective,
  ColumnMenu,
  ColumnsDirective,
  Edit,
  EditSettingsModel,
  ExcelExport,
  Filter,
  FilterSettingsModel,
  GridComponent,
  Inject,
  Page,
  PageSettingsModel,
  Resize,
  Toolbar,
} from '@syncfusion/ej2-react-grids';
import React, { Component } from 'react';
import  { all_information, loadingShow } from '../../../App';
import {
  AddShiftWorkbenchSettings,
  DeleteShiftWorkbenchSettings,
  EditShiftWorkbenchSettings,
  getShiftWorkbenchSettings,
} from '../../../services/ShiftWorkbench/ShitWorkbenchSettingsServices';
import Message from '../../../utils/Message/Message';
interface IState {
  hseqData: any;
}
interface IProps {
  GridHeight?: any;
}
export class Hseq extends Component<IProps, IState> {
  private securityRoleGrid: GridComponent;
  private hseqId: number = -1;
  private isAdd: boolean = true;
  private type: string = 'hseq';
  public validationRule: Object = { required: true };
  constructor(props: IProps) {
    super(props);
    this.securityRoleGrid = new GridComponent(props);
    this.state = {
      hseqData: [],
    };
  }
  public FilterOptions: FilterSettingsModel = { type: 'Menu' };
  public toolbarOptions = [
    'Add',
    'Edit',
    'Delete',
    'Update',
    'Cancel',
    {
      text: 'Refresh',
      tooltipText: 'Refresh',
      prefixIcon: 'e-repeat',
      id: 'refresh-m',
    },
    'ExcelExport',
    'ColumnChooser',
    'Search',
  ];
  public editOptions: EditSettingsModel = {
    allowAdding: true,
    allowDeleting: true,
    allowEditing: true,
    allowEditOnDblClick: true,
    showDeleteConfirmDialog: true,
  };
  public pageOptions: PageSettingsModel = {
    currentPage: 1,
    pageSize: 12,
    pageCount: 8,
    pageSizes: true,
  };
  deleteHseq() {
    const obj = {
      id: this.hseqId,
    };
   
    DeleteShiftWorkbenchSettings(obj)
      .then((res) => {
        loadingShow(false);
        Message.success('Successfully');
        this.getHseq(this.type);
      })
      .catch((err) => {
        loadingShow(false);
        if (err.response) {
          Message.error(err.response.data+"\n"+err.response.status+"\n"+err.response.headers);
        } else if (err.request) {
          Message.error(err.request);
        } else {
          Message.error('Error: ' + err.message);
        }
      });
  }
  addHseq(objCommer: any) {
    const obj = {
      app: 'UWORK',
      user_id: all_information.user_id,
      organization_id: all_information.company_id?.toString(),
      description: objCommer.description,
      hse: objCommer.hse,
      id: objCommer.id,
      type:this.type
    };

    if (this.isAdd) {
      delete obj.id
      AddShiftWorkbenchSettings(obj)
        .then((res) => {
          loadingShow(false);
          Message.success('Successfully');
          this.getHseq(this.type);
        })
        .catch((err) => {
          loadingShow(false);
          if (err.response) {
            Message.error(err.response.data);
            Message.error(err.response.status);
            Message.error(err.response.headers);
          } else if (err.request) {
            Message.error(err.request);
          } else {
            Message.error('Error: ' + err.message);
          }
        });
    } else {
      EditShiftWorkbenchSettings(obj)
        .then((res) => {
          loadingShow(false);
          Message.success('Successfully');
          this.getHseq(this.type);
        })
        .catch((err) => {
          loadingShow(false);
          if (err.response) {
            Message.error(err.response.data);
            Message.error(err.response.status);
            Message.error(err.response.headers);
          } else if (err.request) {
            Message.error(err.request);
          } else {
            Message.error('Error: ' + err.message);
          };
        });
    }
  }
  actionBegin(args: any) {
    if (args.requestType === 'refresh-m') {
      this.getHseq(this.type);
    }
    if (args.action === 'add') {
      this.isAdd = true;
      this.addHseq(args.data);
    } else if (args.action === 'edit') {
      this.isAdd = false;
      this.addHseq(args.data);
    } else if (args.requestType === 'delete') {
      this.hseqId = args.data[0].id;
      this.deleteHseq();
    }
  }
  componentDidMount() {
    this.getHseq(this.type);
  }

  getHseq(type:string) {
    getShiftWorkbenchSettings(type)
      .then((el) => {
        this.setState({ hseqData: el.data });
      })
      .catch((e) => {
        //(e);
      });
  }
  render() {
    return (
      <div>
        <GridComponent
          editSettings={this.editOptions}
          toolbar={this.toolbarOptions}
          dataSource={this.state.hseqData}
          height='65vh'
          ref={(theGrid: GridComponent) => (this.securityRoleGrid = theGrid)}
          filterSettings={this.FilterOptions}
          allowFiltering={true}
          enablePersistence
          allowPaging={true}
          actionBegin={this.actionBegin.bind(this)}
          pageSettings={this.pageOptions}
          allowExcelExport
          showColumnMenu={true}
          allowResizing={true}
          gridLines='Both'
        >
          <ColumnsDirective>
            <ColumnDirective
              field='hse'
              headerText='HSEQ Name'
              textAlign='Left'
              validationRules={this.validationRule}
            />
            <ColumnDirective
              field='description'
              headerText='Description'
              textAlign='Left'
              validationRules={this.validationRule}
            />
          </ColumnsDirective>
          <Inject
            services={[
              Edit,
              Toolbar,
              Filter,
              ColumnChooser,
              ExcelExport,
              Page,
              ColumnMenu,
              Resize,
            ]}
          />
        </GridComponent>
      </div>
    );
  }
}

export default Hseq;
